import React, { useEffect } from "react";
import { FormControl, FormHelperText, Stack } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";

import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";

import { FormFieldProps } from "./index";

import { useTranslation } from "../../../contexts/TranslationContext";
import { useFormErrors } from "../../../contexts/FormContext";

dayjs.extend(advancedFormat);

export default function DateFormField({
                                        type,
                                        name,
                                        label,
                                        value,
                                        onChange,
                                        onKeyUp,
                                        attr
                                      }: FormFieldProps) {
  const { i18n, translate } = useTranslation();
  const { error } = useFormErrors(name);


  useEffect(() => {
    if (i18n) {
      dayjs.locale(i18n.substring(0, 2));
    }
  }, [i18n]);

  let dateVal = null;
  try {
    if (value && dayjs(value).isValid()) {
      dateVal = dayjs(value);
    }
  } catch (e) {
  }

  return (
    <FormControl
      fullWidth
      error={Boolean(error)}
      sx={{
        borderColor: theme =>
          error ? theme.palette.error.main : theme.palette.divider
      }}>
      <Stack spacing={0.5}>
        <DatePicker
          label={translate(label)}
          value={dateVal}
          onChange={value => onChange(value?.toISOString() ?? "")}
          displayWeekNumber
          timezone="system"
          slotProps={{
            textField: {
              InputLabelProps: {
                sx: { lineHeight: 1, color: "text.secondary" }
              }
            }
          }}
        />
        {Boolean(error) && (
          <FormHelperText error={Boolean(error)} id={name + "-error"}>
            {translate(error ?? "error")}
          </FormHelperText>
        )}
      </Stack>
    </FormControl>
  );
}
